/* eslint-disable quotes */
import axios from "@/util/axios";
const loginUrlMap = {
    meeting_webview_tapd_login: 'api/meeting/user/login/meeting_webview_tapd_login',
    meeting_webview: 'api/meeting/user/login/meeting_webview',
    meeting: '/api/meeting/user/login/web',
    bk: '/api/user/login'
}
export default {
    login(code, type, options = []) {
        const url = type && loginUrlMap[type] ? loginUrlMap[type] : loginUrlMap['bk'];
        return axios.post(url, { code: code, options: options});
    },
    addFeed: function(action, actionVal = ''){
        return axios.post('/api/feed/add', { action: action, actionVal: actionVal});
    },
    urlEncode: function(str){
        str = str.replace(/%/g, "%25");
        str = str.replace(/:/g, "%3A");
        str = str.replace(/\//g, "%2F");
        str = str.replace(/\?/g, "%3F");
        str = str.replace(/=/g, "%3D");
        str = str.replace(/&/g, "%26");
        str = str.replace(/\+/g, "%2B");
        str = str.replace(/\s/g, "%20");
        str = str.replace(/#/g, "%23");
        return str;
    },
    urlDecode: function(str){
        str = str.replace(/%3A/g, ":");
        str = str.replace(/%2F/g, "/");
        str = str.replace(/%3F/g, "?");
        str = str.replace(/%3D/g, "=");
        str = str.replace(/%26/g, "&");
        str = str.replace(/%2B/g, "+");
        str = str.replace(/%20/g, " ");
        str = str.replace(/%23/g, "#");
        str = str.replace(/%25/g, "%");
        return str;
    }
}